import React, {useEffect, useState} from 'react';
import {ReportForm, showWarningNotify} from "../../components";
import {Card, CardContent, Grid} from '@material-ui/core';
import {AutocompleteArrayInput, DateInput, ReferenceArrayInput, required, SelectArrayInput, Title} from 'react-admin';
import env from "../../env";
import moment from 'moment'
import {downloadFilePost} from "../../components/FileDownload";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import cachedApis from "../../api/cachedApis";
import utils from "../../utils/utils";

const ATTENDANCE_STATUS = [
    {id: 'ON_TIME', name: 'Đúng giờ (ĐG)'},
    {id: 'IN_LATE', name: 'Trễ (TR)'},
    {id: 'CM', name: 'CM'},
    {id: 'MISSING_CARD', name: 'Không thẻ (KT)'},
    {id: 'ABSENT_WITH_PERMISSION', name: 'Vắng có phép (CP)'},
    {id: 'ABSENT', name: 'Vắng chưa xin phép (KP)'},
    {id: 'OFF', name: 'OFF'},
]
const EventStatusReport = ({...props}) => {
    const [loading, setLoading] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [values, setValues] = useState({
        statuses: [],
        customerIds: [],
        eventIds: [],
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    });
    let timeout;
    useEffect(() => {
        getCustomersWithUnits();
    }, []);

    function getCustomersWithUnits() {
        cachedApis.getCustomerUnits(true).then(rs => {
            setCustomers(rs);
        })
    }

    function excelReport() {
        if (values.eventIds.length == 0) {
            showWarningNotify('Cần chọn sự kiện')
            return;
        }
        if (values.customerIds.length == 0) {
            showWarningNotify('Cần chọn danh sách học sinh')
            return;
        }
        setLoading(true)
        const data = {
            statuses: values.statuses,
            fromDate: values.fromDate,
            toDate: values.toDate,
            eventIds: values.eventIds,
            customerIds: utils.extractCustomerIds(values.customerIds)
        }
        downloadFilePost(`${env.reportURL}/reports/trang-thai-diem-danh-su-kien`, 'bao_cao_trang_thai_diem_danh_su_kien.xlsx', data).then(r => setLoading(false)).catch(e => setLoading(false))
    }

    function validate(val) {
        const errors = {};

        if (val.fromDate && val.toDate && (val.fromDate > val.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }

        setValues({
            ...values,
            eventIds: val.eventIds,
            fromDate: val.fromDate,
            toDate: val.toDate
        })

        return errors;
    }

    const onChange = (prop, e) => {
        if (!e) {
            return
        }

        let value
        if (['customerIds'].includes(prop)) {
            value = e;
        } else {
            if (e.target) {
                value = e.target.value ? e.target.value : e.target.checked;
            } else {
                value = e
            }
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            setValues({...values, [prop]: value});
        }, 500);
    };
    return (
        <Card>
            <Title title="resources.bc-trang-thai-diem-danh-su-kien.name"/>
            <CardContent>
                <ReportForm validate={validate}
                            excelReport={excelReport}
                            params={values}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="fromDate" validate={required()} {...props}
                                       label={'resources.common.fromDate'}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput source="toDate" validate={required()} {...props}
                                       label={'resources.common.toDate'}/>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <ReferenceArrayInput source="eventIds"
                                                 reference="events"
                                                 validate={required()}
                                                 label={'resources.events.name'}
                                                 perPage={100}
                                                 style={{
                                                     minWidth: 200,
                                                 }}
                                                 filter={{enabled: true}}
                                                 sort={{field: 'name', order: 'ASC'}}
                                                 {...props}>
                                <AutocompleteArrayInput optionText="name"
                                                        onChange={(e) => onChange('eventIds', e)}/>
                            </ReferenceArrayInput>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{maxHeight: '300px', marginTop: 30}}>
                            <label><b>Danh sách Học sinh *</b></label>
                            <div style={{maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                                <TreeCheckBoxCustomInput data={customers}
                                                         expandTopLevel={true}
                                                         onChange={(e) => onChange('customerIds', e)}/>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SelectArrayInput source="statuses" choices={ATTENDANCE_STATUS}
                                              label={'resources.common.status'}
                                              onChange={(e, value) => onChange('statuses', value)}
                                              style={{minWidth: 200}}
                            />
                        </Grid>

                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default EventStatusReport
